export default __webpack_public_path__ + "static/media/03__o_preview_5.8018f030.jpg";